import * as React from "react"
import { PropsWithChildren } from "react"

import { ImageContainer, Section, SectionContainer, SectionImage } from "./styles"
import { useSectionImages } from "../../../hooks/use-section-images"

export interface SectionConfig {
  image: string;
  reversed: boolean;
}

export default function SectionComponent(props: PropsWithChildren<SectionConfig>) {
  const { alt, srcSet } = useSectionImages().find(sectionImg => sectionImg.name === props.image)

  return (
    <Section reversed={props.reversed}>
      <ImageContainer reversed={props.reversed}>
        <SectionImage srcSet={srcSet} alt={alt}/>
      </ImageContainer>
      <SectionContainer reversed={props.reversed}>{props.children}</SectionContainer>
    </Section>
  )
}
